import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button } from '@mui/material';
import DashboardLayout from '../Sidebar/DashboardLayout';
import GenericTable from '../../commun/GenericTable';
import Pagination from '../../commun/Pagination';
import ActionButtons from '../../commun/ActionButtons';
import AjouterTalentModal from '../../commun/AddTalentModal';
import CustomAlert from '../../commun/CustomAlert';
import { showDeleteConfirmation } from '../../commun/deletemsg';
import './Cvthèque.css';
import { Dialog, DialogContent } from '@mui/material';
import DetailTalent from '../../Recruteur/candidat/detailTalent/detailTalent';
import TableFilterControls from '../../commun/TableFilterControls';
import { useLocation, useNavigate } from 'react-router-dom'; 
import Chatbox from '../../commun/ChatBox';
import { statusOptions } from '../../commun/constants/options';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const CvthequeDashboard = () => {
  const [displayMode, setDisplayMode] = useState('table');
  const [candidats, setCandidats] = useState([]);
  const [page, setPage] = useState(1);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertSeverity, setAlertSeverity] = useState('success');
  const [showAjouterTalentModal, setShowAjouterTalentModal] = useState(false);
  const [showTalentDetail, setShowTalentDetail] = useState(false);
  const [selectedTalentId, setSelectedTalentId] = useState(null);
  const [searchValue, setSearchValue] = useState('');
  const [statusValue, setStatusValue] = useState('');
  const [selectedRows, setSelectedRows] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const formData = location.state?.plainFormData ;
  const userRole = localStorage.getItem('userType');
  const itemsPerPage = 5;

  useEffect(() => {
    const fetchCandidats = async () => {
      try {
        const [resTalents, resCandidats] = await Promise.all([
          axios.get(`${API_BASE}/api/recruteur/get-candidats`),
          axios.get(`${API_BASE}/api/admin/candidats`)
        ]);
        
        let combinedCandidats = [...resTalents.data, ...resCandidats.data];
    
        if (userRole === 'agent') {
          combinedCandidats = combinedCandidats.filter(c => (c.origine || '').toLowerCase() === 'agent');
        }
    
        setCandidats(combinedCandidats);
      } catch (err) {
        console.error('Erreur récupération des candidats:', err);
      }
    };    

    fetchCandidats();
  }, []);

  useEffect(() => {
    setPage(1);
  }, [searchValue, statusValue]);

  useEffect(() => {
    const talentIdFromState = location.state?.talentIdToOpen;
    if (talentIdFromState) {
      setSelectedTalentId(talentIdFromState);
      setShowTalentDetail(true);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);

  const filteredCandidats = candidats.filter((candidat) => {
    const fullName = `${candidat.nomCandidat || candidat.utilisateur?.lastName || ''} ${candidat.prenomCandidat || candidat.utilisateur?.firstName || ''}`.toLowerCase();
    const status = (candidat.statut || '').toLowerCase();
    const matchesSearch = fullName.includes(searchValue.toLowerCase());
    const matchesStatus = statusValue ? status === statusValue.toLowerCase() : true;
    return matchesSearch && matchesStatus;
  });

  const handleDelete = (item) => {
    const { _id, origine } = item; 
    showDeleteConfirmation({
      onConfirm: async () => {
        try {
          if (origine === 'Candidat') {
            await axios.delete(`${API_BASE}/api/admin/candidat/delete/${_id}`);
          } else {
            await axios.delete(`${API_BASE}/api/recruteur/delete-talents/${_id}`);
          }
          setCandidats(prev => prev.filter(c => c._id !== _id));
          setAlertMessage('Suppression réussie !');
          setAlertSeverity('success');
        } catch (error) {
          console.error('Erreur suppression:', error);
          setAlertMessage("Erreur lors de la suppression.");
          setAlertSeverity('error');
        } finally {
          setAlertOpen(true);
        }
      },
    });
  };

  const handleDeleteSelected = async (ids) => {
    if (!ids.length) return;
    showDeleteConfirmation({
      onConfirm: async () => {
        try {
          for (const id of ids) {
            const candidat = filteredCandidats.find(c => (c._id || c.id) === id);
            if (!candidat) continue;
            if (candidat.origine === 'Candidat') {
              await axios.delete(`${API_BASE}/api/admin/candidat/delete/${id}`);
            } else {
              await axios.delete(`${API_BASE}/api/recruteur/delete-talents/${id}`);
            }
          }
          setCandidats(prev => prev.filter(c => !ids.includes(c._id || c.id)));
          setAlertMessage('Suppression groupée réussie !');
          setAlertSeverity('success');
          setSelectedRows([]);
        } catch (error) {
          console.error('Erreur suppression groupée:', error);
          setAlertMessage("Erreur lors de la suppression groupée.");
          setAlertSeverity('error');
        } finally {
          setAlertOpen(true);
        }
      }
    });
  };

  const handleDownload = (cvFilename) => {
    window.open(`${API_BASE}/api/recruteur/uploads/${cvFilename}`, '_blank');
  };

  const handleView = (talentId) => {
    setSelectedTalentId(talentId);
    setShowTalentDetail(true);
  };
   const baseColumns = [
    {
      key: 'createdAt',
      label: 'Créé le',
      render: (_, row) => {
        const createdAt = row.createdAt || row.utilisateur?.createdAt;
        return createdAt
          ? new Date(createdAt).toLocaleString('fr-FR', {
              day: '2-digit', month: '2-digit', year: 'numeric',
              hour: '2-digit', minute: '2-digit',
            })
          : '-';
      },
    },
    { key: 'lastName', label: 'Nom', render: (_, row) => row.nomCandidat || row.utilisateur?.lastName || '-' },
    { key: 'firstName', label: 'Prénom', render: (_, row) => row.prenomCandidat || row.utilisateur?.firstName || '-' },
    {
      key: 'email',
      label: 'Email',
      render: (_, row) => {
        const email = row.email || row.utilisateur?.email;
        return email ? <a href={`mailto:${email}`} className="link-action">{email}</a> : '-';
      },
    },
    {
      key: 'phone',
      label: 'Téléphone',
      render: (_, row) => {
        const phone = row.phone || row.utilisateur?.phone;
        return phone ? <a href={`tel:${phone}`} className="link-action">{phone}</a> : '-';
      },
    },
    {
      key: 'statut',
      label: 'Statut',
      render: (_, row) => {
        const rawStatus = row.statut || 'Débutant';
    
        const matched = statusOptions.find((s) => s.value === rawStatus);
    
        if (matched) {
          return <span className="status-badge" style={matched.style}>{matched.label}</span>;
        } else {
          return <span className="status-badge">{rawStatus}</span>; 
        }
      }
    },
    {
      key: 'ajoutePar',
      label: 'Ajouté par',
      render: (_, row) => {
        const recruteur = row.recruteurId;
        if (!recruteur) return '-';
        return typeof recruteur === 'object'
          ? `${recruteur.firstName || ''} ${recruteur.lastName || ''}`.trim()
          : `ID: ${recruteur}`;
      },
    }
  ];

    baseColumns.push({
      key: 'origine',
      label: 'Origine',
      render: (_, row) => row.origine || '-',
    });
  
  const columns = baseColumns;

  const renderActions = (row) => (
    <ActionButtons
      onDelete={() => handleDelete(row)}
      onDownload={() => handleDownload(row.cv)}
      showEdit={false}
      showDownload={false}
      onView={() => handleView(row._id)}
    />
  );

  return (
    <section className="dashboardContainer">
      <div className="headerTalentWrapper">
        <h3 className="componentTitle">La Cvthèque</h3>
        <div className="top-controlsC">
          <Button
            variant="contained"
            onClick={() => setShowAjouterTalentModal(true)}
            sx={{ fontWeight: 'bold' }}
          >
            Ajouter un Talent
          </Button>
          <TableFilterControls
            searchValue={searchValue}
            onSearchChange={setSearchValue}
            statusValue={statusValue}
            onStatusChange={setStatusValue}
            statusLabel="Statut"
            statusOptions={statusOptions}
          />
        </div>
      </div>

      <CustomAlert
        open={alertOpen}
        message={alertMessage}
        severity={alertSeverity}
        onClose={() => setAlertOpen(false)}
      />

      <GenericTable 
      
        columns={columns} 
        data={filteredCandidats}   
        renderActions={renderActions} 
        currentPage={page} 
        itemsPerPage={itemsPerPage} 
        setPage={setPage}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        onDeleteSelected={handleDeleteSelected}
        showDeleteButton={true}
        showCheckboxes={true}
        totalItems={candidats.length}
        displayMode={displayMode}
        setDisplayMode={setDisplayMode}

      />

      <Pagination
        page={page}
        setPage={setPage}
        totalItems={filteredCandidats.length}
        itemsPerPage={itemsPerPage}
      />


      <AjouterTalentModal
        open={showAjouterTalentModal}
        onClose={() => setShowAjouterTalentModal(false)}
      />

      <Dialog 
        open={showTalentDetail} 
        onClose={() => setShowTalentDetail(false)} 
        fullWidth 
        maxWidth="lg"
      >
        <DialogContent style={{ padding: 0 }}>
          {selectedTalentId && (
            <DetailTalent 
              talentId={selectedTalentId} 
              formData={formData}
              isModal 
              onUpdate={(updatedTalent) => {
                setCandidats(prev =>
                  prev.map(talent => talent._id === updatedTalent._id ? updatedTalent : talent)
                );
              }}
            />
          )}
        </DialogContent>
      </Dialog>
      {userRole !== 'agent' && <Chatbox userRole={userRole} />}
    </section>
  );
};

const Cvthèque = () => (
  <DashboardLayout>
    <CvthequeDashboard />
  </DashboardLayout>
);

export default Cvthèque;
